import { ColGroupDef } from '@ag-grid-community/core';

import { decimalDivide } from '@shared/utils';
import { getCellClassForGroups } from '@shared/utils/ag-cell-class-for-groups';
import { Utils } from '@shared/utils/utils';

import {
  currencyFormatter,
  defaultHeaderClass,
  defaultMinWidth,
  defaultWidthForMoneyColumns,
  InMonthAdjustmentGridConfigContext,
} from './ima-grid-config-context';

export const imaCurrentForecastColumnGroup = (
  _ctx: InMonthAdjustmentGridConfigContext
): ColGroupDef => {
  return {
    children: [
      {
        cellClass: (params) => ['text-right', ...getCellClassForGroups(params)],
        field: 'current_forecast_percentage',
        filter: 'agNumberColumnFilter',
        headerClass: defaultHeaderClass,
        headerName: 'Monthly % Complete',
        headerTooltip: 'Monthly % Complete',
        minWidth: defaultMinWidth,
        valueFormatter: ({ value }) =>
          Utils.percentageFormatter(decimalDivide(value, 100), { maximumFractionDigits: 4 }),
        valueGetter: (params) => {
          // For Category/Group and Discount rows
          if (!params.data || params.data.cost_category_name === 'Discount') {
            const total_amount = params.data.total_amount;
            const current_forecast_amount = params.data.current_forecast_amount;

            return (current_forecast_amount / total_amount) * 100;
          }

          return params.data.current_forecast_percentage;
        },
        width: 135,
      },
      {
        cellClass: (params) => ['text-right', ...getCellClassForGroups(params)],
        field: 'current_forecast_unit',
        filter: 'agNumberColumnFilter',
        headerClass: defaultHeaderClass,
        headerName: 'Monthly Units',
        headerTooltip: 'Monthly Units',
        minWidth: defaultMinWidth,
        valueFormatter: ({ value }) => Utils.decimalFormatter(value),
        width: 115,
      },
      {
        cellClass: (params) => ['text-right', ...getCellClassForGroups(params)],
        field: 'current_forecast_amount',
        filter: 'agNumberColumnFilter',
        headerClass: defaultHeaderClass,
        headerName: 'Monthly Expense ($)',
        headerTooltip: 'Monthly Expense ($)',
        minWidth: defaultMinWidth,
        valueFormatter: currencyFormatter,
        width: defaultWidthForMoneyColumns,
      },
    ],
    headerClass: ['text-center', 'header-marker', 'blue-light-marker'],
    headerName: 'Current Forecast',
    suppressStickyLabel: true,
  };
};
